import type { AttributionEvidenceType } from "@redotech/redo-attribution-common/attribution-settings";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { BotClicksOverride } from "../filters/marketing-bot-filter";
import { ChannelFilter } from "../filters/marketing-channel-filter";
import { MarketingAnalyticsAutomationPerformance } from "./marketing-analytics-automation-performance";
import { MarketingAnalyticsCampaignPerformance } from "./marketing-analytics-campaign-performance";
import { MarketingAnalyticsKeyRevenueMetrics } from "./marketing-analytics-key-revenue-metrics";
import { MarketingAnalyticsMessagePerformance } from "./marketing-analytics-message-performance";
import { MarketingAnalyticsSentimentTopics } from "./marketing-analytics-sentiment-topics";

export const MarketingAnalyticsOverview = memo(
  function MarketingAnalyticsOverview({
    dateFilter,
    attributionDays,
    attributionEvidence,
    channelFilter,
    includeBotClicks,
  }: {
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
    attributionDays: number | undefined;
    attributionEvidence: AttributionEvidenceType[];
    channelFilter: ChannelFilter;
    includeBotClicks: BotClicksOverride;
  }) {
    return (
      <Flex dir="column" gap="4xl" pb="8xl" w="full">
        <MarketingAnalyticsKeyRevenueMetrics
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
          includeBotClicks={includeBotClicks}
        />
        <MarketingAnalyticsCampaignPerformance
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
          includeBotClicks={includeBotClicks}
        />
        <MarketingAnalyticsAutomationPerformance
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
          includeBotClicks={includeBotClicks}
        />
        <MarketingAnalyticsMessagePerformance
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
          includeBotClicks={includeBotClicks}
        />
        <MarketingAnalyticsSentimentTopics dateFilter={dateFilter} />
      </Flex>
    );
  },
);
